/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";

const Logout = () => {
  const loginUrl = "/";
  const navigate = useNavigate();

  useEffect(() => {
    onLogout();
  }, []);

  const onLogout = () => {
    axios
      .get(process.env.REACT_APP_BASE_URL + "/api/logout")
      .then(function (response) {
        if (response.status === 200) {
          localStorage.removeItem("token");
          localStorage.setItem("isLogin", "0");
          navigate(loginUrl);
        }
      })
      .catch(function (error) {
        console.log(error);
        localStorage.removeItem("token");
        localStorage.setItem("isLogin", "0");
        navigate("/");
      });
  };
};

export default Logout;
